import { TableFieldModel } from '@/model/TableList'
// import { OutsourceFieldTable } from './OutsourceFieldTable'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'outsourceCompany',
    fieldName: '外包商',
    width: 150
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'fee',
    fieldName: '总费用',
    isMoney: true,
    textAlign: 'right',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'containsRate',
    fieldName: '是否含税',
    formatType: 'boolean',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'rate',
    fieldName: '税率',
    formatType: 'percent',
    width: 120
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'status',
    fieldName: '状态',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'paid',
    fieldName: '已付金额',
    isMoney: true,
    textAlign: 'right',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'refundApplyAmount',
    fieldName: '申请退款金额',
    isMoney: true,
    textAlign: 'right',
    width: 110
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'paymentAccount',
    fieldName: '付款账户',
    width: 140
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'paymentTime',
    fieldName: '付款日期',
    width: 180
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'comment',
    fieldName: '拒绝理由',
    width: 120
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'accountAlias',
    fieldName: '外包商账户',
    convert: context => {
      const { rowData } = context
      const { account } = rowData
      return account.alias
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'createTime',
    fieldName: '申请时间',
    width: 180
  },

  // ...OutsourceFieldTable,
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'no',
    fieldName: '发票号码',
    width: 120
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'invoiceType',
    fieldName: '发票类型',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'date',
    fieldName: '开票日期',
    width: 120
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'amount',
    fieldName: '发票金额',
    isMoney: true,
    textAlign: 'right',
    width: 120
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'returnAmount',
    fieldName: '已退票金额',
    isMoney: true,
    textAlign: 'right',
    width: 120
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'times',
    fieldName: '申请次数',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'mark',
    fieldName: '备注'
  }
]
